module.exports = __webpack_public_path__ + "img/cross.531d4532.svg";